import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaTrash } from "react-icons/fa";
import api from '../../api/manage_database/SensorReq';
import SelectSensor from '../../components/SelectSensor';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';;

const SensorDelete = () => {

    const [Sensors, setSensors] = useState([]);
    const [selectedSensor, setSelectedSensor] = useState('');

    const [sensorData, setSensorData] = useState();

    const navigate = useNavigate();

    useEffect(() => {
        const fetchSensors = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setSensors(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchSensors();
    }, []);

    const handleDelete = () => {
        const fetchRecord = async () => {
            try {
                const response = await api.get(`record/${selectedSensor}`, {withCredentials: true});
                if (response.data.success) {
                    setSensorData(response.data.payload[0]);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        }
        fetchRecord();
    }

    useEffect(() => {
        const deleteRecord = async () => {
            try {
                const response = await api.delete(`record/${selectedSensor}`, {withCredentials: true});
                if (response.data.success) {
                    toast.success(`${response.data.message}`);
                    navigate(
                        `../record/${selectedSensor}`,
                        {
                            state: {
                                deleteRecordMessage: 'Deleted record from database!',
                                anotherTypeOfPage: true,
                                data: sensorData
                            }
                        }
                    )
                } else {
                    toast.error('Something go wrong! Maybe check internet connection');
                }
            } catch (err) {
                console.log(err.response);
            }
        }

        if (sensorData) {
            deleteRecord();
        }
    }, [sensorData]);

    return (
        <div className='sensor-delete-container'>
            <h2 className='sensor-delete-title'>Sensor</h2>
            <div className='sensor-delete-card'>
                <div className='sensor-delete-label-select-wrapper'>
                    <label
                        htmlFor='sensor-select'
                        className='bold-label'
                    >
                        Sensor:
                    </label>
                    <SelectSensor
                        Sensors={Sensors}
                        selectedSensor={selectedSensor}
                        setSelectedSensor={setSelectedSensor}
                    />
                </div>
                <button className='sensor-delete-button' onClick={handleDelete}>Delete &nbsp; <FaTrash /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    ); 
};

export default SensorDelete;